var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchenginesBro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.17,313.63c46.24,53,92.93,59.71,158.56,72.27s113.82,3.88,149.33-28.13c41-37,39.38-121.76-23.36-151.94-19.6-9.45-42.94-12.31-60.11-25.6C289.8,154.87,263.28,115.41,210.64,108s-88.13,27.9-88.13,27.9C79.28,183.24,51.93,260.59,98.17,313.63Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.17,313.63c46.24,53,92.93,59.71,158.56,72.27s113.82,3.88,149.33-28.13c41-37,39.38-121.76-23.36-151.94-19.6-9.45-42.94-12.31-60.11-25.6C289.8,154.87,263.28,115.41,210.64,108s-88.13,27.9-88.13,27.9C79.28,183.24,51.93,260.59,98.17,313.63Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-206"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.95,
    y: 398.38,
    width: 390,
    height: 16,
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.95,
    y: 398.38,
    width: 390,
    height: 16,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--search-engines--inject-206"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.3,285a5.83,5.83,0,0,0,3.21,3.22c1.13.46,2.64.36,4.38,1.34,3.93,2.21,13.74.24,20.85,1s16.69-7.11,16.69-7.11L390.64,285V257s-29.44,1.23-35.82-1.23-13.49-7.6-16.68-7.36-29.44,3.19-29.44,3.19L317.29,285Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,172.1a29.63,29.63,0,1,0,32.71,26.19h0A29.61,29.61,0,0,0,310,172.1Zm5.88,53.08a23.77,23.77,0,1,1,21-26.25,23.77,23.77,0,0,1-21,26.25Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.84,170.41a29.63,29.63,0,1,0,32.71,26.19h0A29.64,29.64,0,0,0,309.84,170.41Zm5.88,53.08a23.77,23.77,0,1,1,21-26.25A23.77,23.77,0,0,1,315.72,223.49Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.5,
    y: 229.86,
    width: 7.17,
    height: 26.42,
    rx: 2.88,
    transform: "translate(-24.82 36.49) rotate(-6.32)",
    style: {
      fill: "#1890FF",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.88,247l3-.32A4.93,4.93,0,0,1,325.3,251l4.49,40.61a6.3,6.3,0,0,1-5.57,6.95l-.2,0a6.29,6.29,0,0,1-6.95-5.57l-4.49-40.6a4.92,4.92,0,0,1,4.35-5.44Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.24,280.84s-7.11.26-8.11,1.49-.82,5.51,1.11,6c4.92,1.29,15.38.54,15.79-.34s1.25-6-.91-6.55A52,52,0,0,0,321.24,280.84Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.19,270.92s-8.27-.31-9.56,1.18-1.54,7.06.64,7.9c5.56,2.13,18.07,1.3,18.64.2s1.81-6.81-.64-7.73S319.19,270.92,319.19,270.92Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,259.72s-8.84-.34-10.22,1.26-1.65,7.54.68,8.44c6,2.28,19,2.28,19.61,1.1s2.25-8.16-.37-9.15S318,259.72,318,259.72Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,249.24s-8.84-.33-10.22,1.26-1.71,7.72.68,8.44,19,2.28,19.61,1.11,2.25-8.17-.37-9.16S312.9,249.24,312.9,249.24Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.85,278.65a14.91,14.91,0,0,1-4.45-2.06c-7.11-4.91-6.87-16.19-6.87-16.19l-1.71-.49a15.22,15.22,0,0,1-3.93-2.21,35.52,35.52,0,0,1,1,7.11A5.31,5.31,0,0,1,321,270c-2.21.25-3.19.49-3.93-2.45s-4.41-14.72-4.66-16.44c-.22-1.56,2.4-4.34,6.57-5,6.41.52,12.73,2.31,19.19,2.31a13,13,0,0,1,6.25,2.3",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.61,279.27a22.83,22.83,0,0,1-2.34,0",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.84,278.3a22.7,22.7,0,0,1-5.23,1",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.67,
    y1: 275.12,
    x2: 371.5,
    y2: 275.12,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.41,
    y1: 277.57,
    x2: 367.09,
    y2: 277.57,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.53,260.4s4.88,0,8.08-2.91",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.78,257.38a19.4,19.4,0,0,0-.83-3.92",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,266.26s-.93-2.58.2-3.51,4.13-2.27,4.65-1.24,1.65,5.78,1.34,6.71l-.31.93",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "452.55 297.55 368 297.55 368 255.99 452.55 255.99",
    style: {
      fill: "#1890FF",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.2,
    cy: 292.87,
    r: 1.9,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83,216.41a5.83,5.83,0,0,0,3.22-3.21c.46-1.13.35-2.63,1.34-4.38,2.2-3.92.24-13.73,1-20.85s-7.12-16.68-7.12-16.68l1.53-28.21h-28s1.22,29.44-1.23,35.81-7.6,13.5-7.36,16.69S206.42,225,206.42,225l33.36-8.59Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,223.69A29.63,29.63,0,1,0,153.21,191h-.07A29.63,29.63,0,0,0,127,223.69Zm53-5.89a23.78,23.78,0,1,1-26.27-21h0A23.79,23.79,0,0,1,180,217.8Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,223.87a29.62,29.62,0,1,0,26.19-32.71A29.62,29.62,0,0,0,125.27,223.87ZM178.35,218a23.77,23.77,0,1,1-26.25-21,23.77,23.77,0,0,1,26.25,21Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.72,
    y: 212.05,
    width: 26.42,
    height: 7.17,
    rx: 2.88,
    transform: "translate(-22.53 23.1) rotate(-6.32)",
    style: {
      fill: "#1890FF",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.86,216.84l-.33-3a4.93,4.93,0,0,1,4.36-5.44l40.6-4.49a6.31,6.31,0,0,1,7,5.57h0l0,.2a6.31,6.31,0,0,1-5.57,7h0l-40.6,4.49A4.94,4.94,0,0,1,201.86,216.84Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,212.48s.27,7.1,1.49,8.1,5.52.82,6-1.11c1.3-4.91.54-15.38-.34-15.78s-6-1.26-6.54.91A52,52,0,0,0,235.69,212.48Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.78,214.52s-.32,8.27,1.17,9.56,7.06,1.55,7.9-.64c2.14-5.56,1.3-18.07.2-18.63s-6.81-1.81-7.73.64S225.78,214.52,225.78,214.52Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.58,215.73s-.34,8.84,1.25,10.22,7.55,1.65,8.45-.69c2.28-5.94,2.28-19,1.1-19.6s-8.17-2.25-9.15.37S214.58,215.73,214.58,215.73Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.1,220.82s-.34,8.84,1.26,10.22,7.72,1.71,8.44-.69,2.28-19,1.1-19.61-8.16-2.24-9.15.38S204.1,220.82,204.1,220.82Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.12,185.08a17.44,17.44,0,0,1-2.68,11.23c-4.9,7.12-16.19,6.87-16.19,6.87l-.49,1.72a14.87,14.87,0,0,1-2.21,3.92,35.61,35.61,0,0,1,7.12-1,5.32,5.32,0,0,1,5.15,4.91c.25,2.21.49,3.19-2.45,3.92s-14.72,4.42-16.44,4.67c-1.56.22-4.34-2.4-5-6.57.53-6.41,2.32-12.74,2.32-19.19a13,13,0,0,1,2.3-6.26",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.16,179.88a20.15,20.15,0,0,1,.68,2.86",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.97,
    y1: 171.04,
    x2: 229.97,
    y2: 162.21,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.42,
    y1: 170.31,
    x2: 232.42,
    y2: 166.63,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.25,203.18s0-4.88-2.91-8.08",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.24,208.94a19.38,19.38,0,0,0-3.92.82",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.12,216.68s-2.58.93-3.51-.21-2.27-4.13-1.24-4.64,5.78-1.65,6.71-1.34l.93.3",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "252.41 81.16 252.41 165.71 210.84 165.71 210.84 81.16",
    style: {
      fill: "#1890FF",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.72,
    cy: 159.51,
    r: 1.9,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,367a5.8,5.8,0,0,1-3.21,3.22c-1.13.47-2.63.36-4.38,1.34-3.92,2.21-13.73.25-20.85,1s-16.68-7.11-16.68-7.11L124.64,367V339s29.44,1.23,35.82-1.22,13.49-7.61,16.68-7.36,29.44,3.19,29.44,3.19Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.25,254.16a29.63,29.63,0,1,1-32.71,26.19h0a29.62,29.62,0,0,1,32.7-26.18Zm-5.88,53.08a23.78,23.78,0,1,0-21-26.27h0A23.79,23.79,0,0,0,199.37,307.24Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.43,252.47a29.62,29.62,0,1,1-32.71,26.18,29.62,29.62,0,0,1,32.71-26.18Zm-5.88,53.08a23.78,23.78,0,1,0-21-26.27v0a23.78,23.78,0,0,0,21,26.25Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.96,
    y: 321.54,
    width: 26.42,
    height: 7.17,
    rx: 2.88,
    transform: "translate(-147.68 485.31) rotate(-83.68)",
    style: {
      fill: "#1890FF",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.27,380.66l-.2,0a6.3,6.3,0,0,1-5.57-7l4.49-40.6a4.92,4.92,0,0,1,5.44-4.36l3,.33a4.93,4.93,0,0,1,4.36,5.44l-4.49,40.65a6.32,6.32,0,0,1-7,5.57Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,362.89s7.1.27,8.1,1.49.82,5.51-1.11,6c-4.91,1.3-15.38.54-15.78-.34s-1.26-6,.91-6.55A52,52,0,0,1,194,362.89Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.08,353s8.27-.32,9.56,1.17,1.55,7.06-.64,7.9c-5.56,2.13-18.07,1.3-18.63.2s-1.81-6.81.64-7.73S196.08,353,196.08,353Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,341.77s8.84-.33,10.22,1.26,1.65,7.55-.68,8.44c-6,2.29-19,2.28-19.61,1.11s-2.25-8.17.37-9.16S197.29,341.77,197.29,341.77Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.38,331.3s8.84-.34,10.22,1.25,1.71,7.73-.69,8.45-19,2.27-19.61,1.1-2.24-8.17.38-9.15S202.38,331.3,202.38,331.3Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,361.37a16.77,16.77,0,0,0,9.85-2.73c7.12-4.91,6.87-16.19,6.87-16.19l1.72-.49a14.87,14.87,0,0,0,3.92-2.21,35.52,35.52,0,0,0-1,7.11,5.33,5.33,0,0,0,4.91,5.16c2.21.24,3.19.49,3.93-2.46s4.41-14.72,4.66-16.43-2.4-4.35-6.57-5c-6.41.53-12.74,2.32-19.19,2.32a13.08,13.08,0,0,0-6.26,2.29",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.44,360.36a22.36,22.36,0,0,0,4.29.87",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.6,
    y1: 357.17,
    x2: 143.77,
    y2: 357.17,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.87,
    y1: 359.62,
    x2: 148.19,
    y2: 359.62,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.74,342.45s-4.88,0-8.08-2.91",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.5,339.43a19.38,19.38,0,0,1,.82-3.92",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.24,348.31s.93-2.58-.21-3.51-4.13-2.27-4.64-1.24-1.65,5.79-1.34,6.71l.31.93",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "62.72 379.61 147.27 379.61 147.27 338.04 62.72 338.04",
    style: {
      fill: "#1890FF",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.17,374.92a1.9,1.9,0,1,0,1.9-1.9h0A1.9,1.9,0,0,0,139.17,374.92Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchenginesBro);
export default __webpack_public_path__ + "static/media/Search engines-bro.5a82b08041c474d86e48d05f724915d0.svg";
export { ForwardRef as ReactComponent };